import React from "react";
import UserPhoto from "./shared/UserPhoto";
import { useChannelStateContext, useChatContext } from "stream-chat-react";
import { useMemo } from "react";
import "../styles/CustomChannelHeader.css";
import { FaIcon } from "../shared/ui";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { faCalendar } from "@fortawesome/free-regular-svg-icons";
import { useMobileStyles } from "../hooks/useMobileStyles";
import { Sizes } from "../constants";
import { useAppointmentScheduler } from "../hooks/useAppointmentScheduler";
import { useAppSettings } from "../context/AppSettingsContext";
import { useSecondaryChatDisabled } from "../hooks/useChatDisabled";
const CustomChannelHeader = ({onBackClick = () => {}}) => {
  const { channel } = useChannelStateContext();
  const { client } = useChatContext();
  const { scheduleAppointment } = useAppointmentScheduler(channel);
  const { settings } = useAppSettings();
  const { windowWidth, colorStyle, bgColorStyle } = useMobileStyles();
  const isSecondaryDisabled = useSecondaryChatDisabled(channel, client?.userID);
  const canSchedule =
    settings != null &&
    (settings.enableAppointment === true || settings.enableAppointment === 1) &&
    !isSecondaryDisabled;
  const otherMember = useMemo(() => {
    const members = Object.values(channel.state.members);
    return members.find((member) => member.user?.id !== client.userID)?.user;
  }, [channel, client]);

  if (!otherMember) return null;

  return (
    <div
      className="custom-channel-header"
      style={bgColorStyle || undefined}
    >
      <div className="header-content">
        <div className="flex spacing-4">
          {windowWidth <= Sizes.BREAKPOINT_MOBILE ? (
            <button
              className="mobile-back-arrow"
              onClick={e => {
                e.stopPropagation();
                onBackClick && onBackClick(e);
              }}
              aria-label="Back"
            >
              <FaIcon icon={faChevronLeft} size="lg" style={colorStyle || undefined}/>
            </button>
          ) : (
            <UserPhoto
              photo={otherMember.photo}
              firstName={otherMember.name || otherMember.id}
              lastName=""
              customClass="avatar-fallback"
            />
          )}
          <div className="channel-info">
            <div className="channel-name" style={colorStyle || undefined}>
              {otherMember.name || otherMember.id}
            </div>
          </div>
        </div>
        {canSchedule && typeof scheduleAppointment === "function" && (
  <div onClick={scheduleAppointment}>
    <FaIcon
      icon={faCalendar}
      className="p-2 trigger-appointment"
      size="lg"
      ariaLabel="Calendar"
    />
  </div>
)}

      </div>
    </div>
  );
};

export default CustomChannelHeader;